import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MarsinetContext } from '../../../context/marsinetProvider';
import { apiServices } from '../../../services/apiServices';
import OtaUploadForm from './components/ota-upload-form';
import { AvailableResourceActions, can } from '@marsinet/commons';

export function OtaUploadPage() {
  const { role, access_token, setRole, setAdmin, isLogged } = useContext(MarsinetContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAccountData = async () => {
      try {
        const response = await apiServices.myAccountApi.myAccountControllerGetData();
        const data = response.data;
        setRole(data.organization?.role);
      } catch (error) {
        console.error('Error fetching account data:', error);
      }
    };
    if (!access_token) return;
    fetchAccountData();
  }, [access_token, setRole, setAdmin]);

  useEffect(() => {
    if (isLogged && role) {
      if (!can(role, AvailableResourceActions.ota.create)) {
        navigate('/authenticated');
        return;
      }
    }
  }, [role, isLogged, navigate]);

  return (
    <div className="p-4 w-full">
      <OtaUploadForm />
    </div>
  );
}

export default OtaUploadPage;
